import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden pb-[0.14em] -mb-[0.14em] ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const FadeIn = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, light = false, color }) => (
    <p
        className={`text-xs font-semibold uppercase tracking-[0.22em] ${
            color ?? (light ? "text-[#B2D0FF]" : "text-[#0047BB]")
        }`}
    >
        {children}
    </p>
);
